import React, { useState } from "react";

import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import ListingPageComponent from '../../components/ListingPageComponent';
import CirclesStats from '../../components/CirclesStats';
import UiAction from "../../components/UiAction.js";
import UI_ACTIONS from "../../data/UiActionConstants.js";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye } from "@fortawesome/free-solid-svg-icons";
// import FiltersPartial from './FiltersPartial';

const Index = () => {
  const defaultHeaderConfig = { disableSort: false };
  // const [filtersModel, setFiltersModel] = useState({
  //   status: ['submitted', 'pending', 'draft']
  // });
  const navigate = useNavigate();

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Circle Name',
      attr: 'name',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'PIN Code',
      attr: 'pincode',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Address',
      attr: 'address',
      disableSort: true
    },
    {
      disableSort: true,
      label: 'Action',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.update_circle.name)}>
            <div style={{cursor: 'pointer'}} onClick={(e) => onEditClick(row.id) }>
              <FontAwesomeIcon icon={faEdit}/>
            </div>
          </UiAction>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.view_circle.name)}>
            <div style={{ cursor: 'pointer' }} onClick={(e) => onViewClick(row.id)}>
              <FontAwesomeIcon icon={faEye} />
            </div>
          </UiAction>
        </div>
      }
    }
  ]

  const onNewClick = () => {
    navigate('/circles/new');
  }

  const onViewClick = (id) => {
    navigate(`/circles/${id}`)
  }

  const onEditClick = (id) => {
    navigate(`/circles/${id}/edit`)
  }

  const tableHeaderActionsComponent = () => {
    return <React.Fragment>
      <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.create_circle.name)}>
        <button className="s-btn me-2" style={{ width: "150px" }} onClick={onNewClick}>
          <span>Add New Circle</span>
        </button>
      </UiAction>
    </React.Fragment>
  }

  return <>
    <ListingPageComponent
      key={PAGES.CirclesListingPage.name}
      uiPage={uiManager.getUiPage(PAGES.CirclesListingPage.name)}
      breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Circle', url: '/circles'}]}
      listingMutation={getApi('branches')}
      className="circles-listing-page"
      contentHeading="All Circles - Results"
      headers={headers}
      recordsKey="branches"
      contentTop={<CirclesStats />}
      searchBy={['ID', 'Circle Name']}
      // filters={
      //   <FiltersPartial
      //     filtersModel={filtersModel}
      //     setFiltersModel={setFiltersModel}
      //   />
      // }
    // filtersModel={filtersModel}
    tableHeaderActionsComponent={tableHeaderActionsComponent()}
  />
  </>
};

export default Index;
